import { RoutePath } from "../../../../../features/routes"
import { DetailWrapper } from "../../../../../features/ui"
import { SalaryDetail } from "./salaryDetail"

export const SalaryDetailLoader = () => (
    <DetailWrapper parentPath={RoutePath.SALARIES}>
        <SalaryDetail />
    </DetailWrapper>
)
